import {qs} from '@shared/helpers/queryString'
import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

import {Operator, OperatorType} from '../constants'

const api = getApi(getCommonBaseUrl())

const urls: Record<OperatorType, string> = {
    [Operator.CUSTOMER]: '/delivery/tracking/customer',
    [Operator.SELLER]: '/delivery/tracking/seller',
}

const getDeliveryTrackingInfo = ({
    deliveryNo,
    productOrderNo,
    operatorType,
}: {
    deliveryNo: string
    productOrderNo: string
    operatorType: OperatorType
}) => {
    return createWrapper<SchemasUniversalDelivery['/delivery/tracking']['response']>(
        api.get(
            qs.stringifyUrl({
                url: urls[operatorType],
                query: {deliveryNo, productOrderNo},
            }),
        ),
    )
}

export default {
    getDeliveryTrackingInfo,
}
